import { IParentBusiness } from '../entities/Business';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';

/**
 * 親取引のファクトリークラス
 */
export class ParentBusinessFactory {
  /**
   * IParentBusinessを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<IParentBusiness> = {}): IParentBusiness => {
    return {
      ...BusinessFactory.create(initialData),
      children: initialData.children ?? [],
      aggregateGroup: initialData.aggregateGroup ?? [],
      childrenAsyncStatus: initialData.childrenAsyncStatus ?? 'none',
      editData: initialData.editData ?? { amount: 0, date: new Date() },
      recommend: initialData.recommend ?? [],
      inventoryConditionAtExecutionDate: initialData.inventoryConditionAtExecutionDate ?? 'Normal',
      recommendEstimateTime: initialData.recommendEstimateTime,
      recommendArrivalValue: initialData.recommendArrivalValue,
    };
  };
}
